import { FC } from 'react';
import { cn } from '@/lib';
import { useBodyScrollLock } from '@/hooks/useBodyScrollLock';
import { AccountsSection, MoreOptionsSection, OtherSection } from './components';

interface MobileMoreModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const MobileMoreModal: FC<MobileMoreModalProps> = ({ isOpen, onClose }) => {
    useBodyScrollLock(isOpen);

    return (
        <>
            {/* Backdrop */}
            <div
                className={cn(
                    'fixed inset-0 z-40 transition-opacity duration-300 lg:hidden',
                    isOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
                )}
                onClick={onClose}
            />

            {/* Modal */}
            <div
                className={cn(
                    'bg-canvas fixed inset-x-0 z-40 flex flex-col transition-transform duration-300 ease-in-out lg:hidden',
                    'h-[calc(100%-var(--spacing-bottom-menu-bar))]',
                    isOpen
                        ? 'h-[calc(100%-var(--spacing-bottom-menu-bar))] translate-y-0'
                        : 'pointer-events-none translate-y-full'
                )}
            >
                <div className='flex flex-1 flex-col gap-8 overflow-y-auto p-6'>
                    <MoreOptionsSection onClose={onClose} />
                    <OtherSection onClose={onClose} />
                    <AccountsSection onClose={onClose} />
                </div>
            </div>
        </>
    );
};
